export default __webpack_public_path__ + "static/avatar-1-101011a98ca1209536053fc1d7375514.jpg";